<template>
    <div class="divForm">
        <h4 class="titre">Saisissez vos informations</h4>
        <form action="#" class="allForm" id="formulaire" autocomplete="off">
            <div id="formContact">
                <h5><i v-if="!noEmojis" class="em em-man-gesturing-ok" aria-role="presentation" aria-label=""></i>Contact et facturation</h5>
                <template v-if="$store.getters.reservation_client.client.typeClient === 'Professionnel'">
                    <label for="formSociete" id="labelFormSociete">Société<span class="asterisk">&nbsp;*</span></label>
                    <input v-model="contact.Societe" type="text" name="formSociete" id="formSociete" maxlength="50">
                </template>
                <div class="doubleInput">
                    <div>
                        <label for="formPrenom*">Votre prénom<span class="asterisk">&nbsp;*</span></label>
                        <input v-model="contact.Prenom" type="text" name="formPrenom" id="formPrenom" maxlength="50">
                    </div>
                    <div>
                        <label for="formNom">Votre nom<span class="asterisk">&nbsp;*</span></label>
                        <input v-model="contact.Nom" type="text" name="formNom" id="formNom" maxlength="50">
                    </div>
                </div>
                <div class="doubleInput">
                    <div>
                        <label for="formTel" id="labelFormTel">Votre téléphone<span class="asterisk">&nbsp;*</span></label>
                        <input v-model="contact.telClient" type="tel" name="formTel" id="formTel" maxlength="20">
                    </div>
                    <div>
                        <label for="formMail" id="labelFormMail">Votre e-mail<span class="asterisk">&nbsp;*</span></label>
                        <input v-model="contact.mailClient" type="email" name="formMail" id="formMail" maxlength="50">
                    </div>
                </div>
                <label for="formAdresseL1">Votre adresse de facturation<span class="asterisk">&nbsp;*</span></label>
                <vue-google-autocomplete :country="['fr']" id="adresseClient" v-model="contact.Adresse" v-on:placechanged="getAddressData" placeholder="adresse précise de facturation"></vue-google-autocomplete>
                <p id="champsObligatoires"><span class="asterisk">*&nbsp;</span>champs obligatoires</p>
            </div>
            <div id="formInfoEvent">
                <h5><i v-if="!noEmojis" class="em em-musical_note" aria-role="presentation" aria-label="MUSICAL NOTE"></i>Informations sur l'événement</h5>
                <div class="doubleInput">
                    <div>
                        <label for="formTypeEvenement">Type d'événement<span class="asterisk">&nbsp;*</span></label>
                        <select v-model="evenement.Type" list="listTypeEvent" name="formTypeEvenement" id="formTypeEvenement">
                            <option selected="selected" value="Je ne sais pas encore">Je ne sais pas encore</option>
                            <option value="Mariage">Mariage</option>
                            <option value="Soirée entreprise">Soirée entreprise</option>
                            <option value="Soirée du personnel">Soirée du personnel</option>
                            <option value="Anniversaire">Anniversaire</option>
                            <option value="Anniversaire de mariage">Anniversaire de mariage</option>
                            <option value="Assemblée générale">Assemblée générale</option>
                            <option value="Bal de promo">Bal de promo</option>
                            <option value="Bar Mitzvah">Bar Mitzvah</option>
                            <option value="Bat Mitsvah">Bat Mitsvah</option>
                            <option value="Cadeau">Cadeau</option>
                            <option value="Enterrement de vie de garçon">Enterrement de vie de garçon</option>
                            <option value="Enterrement de vie de  jeune fille">Enterrement de vie de jeune fille</option>
                            <option value="Fête de quartier">Fête de quartier</option>
                            <option value="Fiançailles">Fiançailles</option>
                            <option value="Gala">Gala</option>
                            <option value="Halloween">Halloween</option>
                            <option value="Inauguration">Inauguration</option>
                            <option value="Kermesse">Kermesse</option>
                            <option value="Noël">Noël</option>
                            <option value="Réveillon">Réveillon</option>
                            <option value="Salons">Salons</option>
                            <option value="Séminaire">Séminaire</option>
                            <option value="Soirée">Soirée</option>
                            <option value="Autre (Précisez en commentaire)">Autre (Précisez en commentaire)</option>
                        </select>
                    </div>
                    <div>
                        <label for="formNbInvite">Nombre d'invités ?</label>
                        <input v-model="evenement.NbInvites" type="number" pattern="\d*" name="formNbInvite" id="formNbInvite">
                    </div>
                </div>
                <div class="doubleInput">
                    <div>
                        <label for="formHeureInstal" id="labelFormHeureInstal">Heure de retrait</label>
                        <select v-model="evenement.HeureDebut" type="text" name="formHeureInstal" id="formHeureInstal">
                        </select>
                    </div>
                    <div>
                        <label v-if="this.$store.getters.reservation_client.borne.name != 'Miroir'" for="formHeureDesinstal" id="labelFormHeureDesinstal">Heure de retour</label>
                        <select v-if="this.$store.getters.reservation_client.borne.name != 'Miroir'" v-model="evenement.HeureFin" type="text" name="formHeureDesinstal" id="formHeureDesinstal">
                        </select>
                    </div>
                </div>
                <label for="formCom">Commentaire(s)</label>
                <textarea v-model="evenement.Commentaire" cols="40" rows="1" id="formCom" name="formCom" maxlength="280" @input="updateHeightTextArea()"></textarea>
                <p id="counterCommentary">{{ evenement.Commentaire ? evenement.Commentaire.length : 0 }} / 280</p>
            </div>
        </form>
        <div class="navBar">
            <div @click="prevStep" id="prevStep">
                <span class="button bigScreen">Étape précédente</span>
                <img class="arrow littleScreen" :src="'https://preprod.api.defipix.fr/logos/prev_200.png'" alt="previous step" />
            </div>
            <div@click="nextStep" id="nextStep">
                <span class="button bigScreen nextStep">Étape suivante</span>
                <img class="arrow littleScreen" :src="'https://preprod.api.defipix.fr/logos/next_200.png'" alt="next step" />
            </div>
        </div>
    </div>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import JQuery from 'jquery'
let $ = JQuery
import NavBar from '@/components/OrderBooth/NavBar'

export default {
    data() {
        return {
            contact: {
                Nom: this.$store.getters.reservation_client.client.nom,
                Prenom : this.$store.getters.reservation_client.client.prenom,
                Societe: this.$store.getters.reservation_client.client.societe,
                Adresse: this.$store.getters.reservation_client.client.adresse,
                mailClient: this.$store.getters.reservation_client.client.mail,
                telClient: this.$store.getters.reservation_client.client.telPortable,
            },
            evenement: {
                Type: this.$store.getters.reservation_client.evenement.type ? this.$store.getters.reservation_client.evenement.type : "Je ne sais pas encore",
                HeureDebut: "Je ne sais pas encore",
                HeureFin: "Je ne sais pas encore",
                NbInvites: this.$store.getters.reservation_client.evenement.nbInvites,
                Commentaire: this.$store.getters.reservation_client.evenement.commentaire,
            },
            noEmojis: this.$store.getters.reservation_client.noEmojis,
        }
    },
    updated() {
        let tagArr = document.getElementsByTagName("input");
        for (let i = 0; i < tagArr.length; i++) {
            tagArr[i].autocomplete = 'off';
        };
        this.greyButton();
    },
    computed: {
        GOnextStep: function () {
            if (this.contact.Nom && this.contact.Prenom && this.contact.Adresse && this.contact.telClient && this.contact.mailClient && 
            this.evenement.Type && this.contact.Adresse) {
                if (this.$store.getters.reservation_client.client.typeClient === 'Professionnel' && !this.contact.Societe) return false;
                if (this.contact.Adresse.includes(",")) return true;
                return false;
            }
            return true;
        }
    },
    components: {
        NavBar,
        VueGoogleAutocomplete
    },
    mounted: function () {
        $('html,body').animate({scrollTop: 0}, 'slow');
        let modeLiv = this.$store.getters.reservation_client.livraison.mode;
        if (modeLiv == "retrait") {
            $('#labelFormHeureInstal').text("Heure de retrait");
            $("<option class='optHeureInstal' value='Je ne sais pas encore'>Je ne sais pas encore</option>").appendTo("#formHeureInstal");
            $("<option class='optHeureInstal' value='11h00'>11h00</option>").appendTo("#formHeureInstal");
            $("<option class='optHeureInstal' value='15h00'>15h00</option>").appendTo("#formHeureInstal");
            $('#labelFormHeureDesinstal').text("Heure de retour");
            $("<option class='optHeureDesinstal' value='Je ne sais pas encore'>Je ne sais pas encore</option>").appendTo("#formHeureDesinstal");
            $("<option class='optHeureDesinstal' value='Prochain jour ouvrable (10h00-12h00 / 14h00-18h00)'>Prochain jour ouvrable (10h00-12h00 / 14h00-18h00)</option>").appendTo("#formHeureDesinstal");
        } else {
            $('#labelFormHeureInstal').text("Heure d'installation");
            $("<option class='optHeureInstal' value='Je ne sais pas encore'>Je ne sais pas encore</option>").appendTo("#formHeureInstal");
            for (let i = 8; i < 23; i++) {
                if (i < 10) {
                    $("<option class='optHeureInstal' value='J+1: 0" + i + "h00'>0" + i + "h00</option>").appendTo("#formHeureInstal");
                } else {
                    $("<option class='optHeureInstal' value='" + i + "h00'>" + i + "h00</option>").appendTo("#formHeureInstal");
                }
            }
            $('#labelFormHeureDesinstal').text("Heure de désinstallation");
            $("<option class='optHeureDesinstal' value='Je ne sais pas encore'>Je ne sais pas encore</option>").appendTo("#formHeureDesinstal");
        }
        $('#formHeureInstal').click(function () {
            if (modeLiv != "retrait") {
                $('.optHeureDesinstal').remove();
                $("<option class='optHeureDesinstal' value='Je ne sais pas encore'>Je ne sais pas encore</option>").appendTo("#formHeureDesinstal");
                let hInstal = Number($("#formHeureInstal option:selected").text().slice(0, 2));
                let JourPlusUn = false;
                if (hInstal != "No") {
                    for (let i = (hInstal + 1); i < (hInstal + 28); i++) {
                        if (i == 24) {
                            JourPlusUn = true;
                            $("<option class='optHeureDesinstal' value='00h00'>Jour J: 00h00</option>").appendTo("#formHeureDesinstal");
                        }
                        if (!JourPlusUn) {
                            $("<option class='optHeureDesinstal' value='Jour J: " + i + "h00'>Jour J: " + i + "h00</option>").appendTo("#formHeureDesinstal");
                        } else {
                            if ((i - 23) < 10) {
                                $("<option class='optHeureDesinstal' value='J+1: 0" + (i - 23) + "h00'>J+1: 0" + (i - 23) + "h00</option>").appendTo("#formHeureDesinstal");
                            } else {
                                $("<option class='optHeureDesinstal' value='J+1: " + (i - 23) + "h00'>J+1: " + (i - 23) + "h00</option>").appendTo("#formHeureDesinstal");
                            }
                        }
                        if (i == (hInstal + 27)) {
                            $("<option class='optHeureDesinstal' value='autre'>Autre (précisez en commentaire)</option>").appendTo("#formHeureDesinstal");
                        }
                    }
                }
            }
        });
        $("#formNom").text("Nom");
        this.greyButton();
    },
    methods: {
        getAddressData: function (addressData, placeResultData, id) {
            this.contact.Adresse = placeResultData['formatted_address'];
        },
        greyButton() {
            if (this.GOnextStep) {
                $(".nextStep").css('background-color', '#f677c4');
            } else {
                $(".nextStep").css('background-color', 'grey');
                console.log($("#nextStep"));
            }
        },
        nextStep() {
            if (this.GOnextStep) {
                this.$store.commit('RCsetFinalEvent', this.evenement);
                this.$store.commit('RCsetFinalClient', this.contact);
                this.$store.commit('RCetapeNext');
            } else {
                $("#champsObligatoires").fadeIn(100).fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
                $(".asterisk").fadeIn(100).fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
            }
        },
        prevStep() {
            this.$store.commit('RCsetFinalEvent', this.evenement);
            this.$store.commit('RCsetFinalClient', this.contact);
            this.$store.commit('RCetapePrev');
        },
        updateHeightTextArea() {
            $("#formCom").css('height', 'auto');
            $("#formCom").css('height', `${$("#formCom")[0].scrollHeight}px`);
        }
    }
}
</script>

<style scoped>
.divForm {
    margin-bottom: 2em;
    background-color: rgb(248, 248, 248);
    border-radius: 10px;
    padding-top: 2em;
    box-shadow: 0px 0px 5px 0px #aaa;
    background-color: #25327B;
}

h5, h4, h3, h2, h1, p, .recapTitre, label {
    color: #fff !important;
}

h5 {
    text-align: center;
    display: flex;
    align-items: center;
}

.allForm {
    display: grid;
    grid-template-columns: auto auto;
    grid-template-areas:
        'info contact'
        'lieu contact';
    justify-content: center;
    grid-gap: 2em;
    padding: 2em;
}

h3 {
    color: #25327B;
}

select,
textarea,
input {
    width: 27em;
    padding: 5px;
    margin-bottom: 10px;
    border-radius: 5px;
    border: 1px solid #25327B;
    font-weight: bold;
    background-color: white;
}

select,
input {
    height: 2.5em;
}

label {
    display: block;
    margin: 0;
    padding-left: 5px;
    font-size: 14px;
    width: unset !important;
}

#formInfoEvent {
    border-left: 2px solid #f677c4;
    padding-left: 2em;
}

.asterisk {
    color: #f677c4;
}

.doubleInput {
    display: flex;
    justify-content: space-between;
}

.doubleInput>div>* {
    width: 13em;
}

#formTypeEvenement {
    width: 17em;
}

#formNbInvite {
    width: 9em;
}

#formCom {
    min-height: 2.5em;
    resize: none;
    overflow: hidden;
    margin-bottom: 0;
}

#counterCommentary {
    font-size: 12px;
    text-align: end;
}

#champsObligatoires {
    font-size: 14px;
    text-align: right;
}

.navBar {
    margin: 1em;
    padding-bottom: 4em;
}

#prevStep {
    float: left;
    margin: auto;
}

#nextStep {
    float: right;
    margin: auto;
}

#prevStep:hover, #nextStep:hover {
    cursor: pointer;
    transform: scale(1.025);
}

.littleScreen {
    display: none;
}

.arrow {
    width: 2.5em;
}

@media only screen and (max-width: 520px) {
    .bigScreen {
        display: none;
    }
    .littleScreen {
        display: block;
    }
}

@media only screen and (max-width: 1060px) {

    select,
    textarea,
    input {
        width: 98%;
    }

    .doubleInput>div>* {
        width: 95%;
    }

    #formTypeEvenement, #formNbInvite {
        width: 95%;
    }
}

@media only screen and (max-width: 885px) {
    .allForm {
        display: block;
    }

    select,
    textarea,
    input {
        width: 97.5%;
    }

    .doubleInput>div {
        width: 50%;
    }

    #formInfoEvent {
        border: none;
        padding: 0;
        margin-top: 2em;
    }
}

@media only screen and (max-width: 555px) {
    .doubleInput {
        display: block;
    }

    .doubleInput>div, .doubleInput>div>*, select, textarea, input, #formTypeEvenement, #formNbInvite {
        width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/OrderBooth/Form.vue